/* lazyload.js (c) Lorenzo Giuliani | MIT */
!function(g){var f=function(r,o){if(document.querySelectorAll){o=document.querySelectorAll(r)}else{var s=document,n=s.styleSheets[0]||s.createStyleSheet();n.addRule(r,"f:b");for(var m=s.all,i=0,t=[],p=m.length;i<p;i++){m[i].currentStyle.f&&t.push(m[i])}n.removeRule(0);o=t}return o},c=function(i,l){g.addEventListener?this.addEventListener(i,l,false):(g.attachEvent)?this.attachEvent("on"+i,l):this["on"+i]=l},a=function(l,i){return Object.prototype.hasOwnProperty.call(l,i)};function b(m,l){var i=new Image(),n=m.getAttribute("data-src");i.onload=function(){if(!!m.parent){m.parent.replaceChild(i,m)}else{m.src=n;m.setAttribute("lazy","loaded")}l?l():null};i.src=n}function k(i){var l=i.getBoundingClientRect();return(l.top>=0&&l.left>=0&&l.top<=(g.innerHeight||document.documentElement.clientHeight))}var j=new Array(),h=f("img[lazy]"),e=function(){for(var l=0;l<j.length;l++){if(k(j[l])){b(j[l],function(){j.splice(l,l)})}}};for(var d=0;d<h.length;d++){j.push(h[d])}e();c("scroll",e)}(this);

$(document).ready(function(){	
    /*if($('#ca-ins-shop-box').length>0){
        var _swiper = $($('textarea.ca-ins-shop-box-content').val()).get(0);
        $('#ca-ins-shop-box').append(_swiper);
        var _flickity = new Flickity( _swiper, {
            // options
            cellAlign: 'left',
            contain: true,
            pageDots: false,
            resize: true
        });
        window.addEventListener('resize', function(event) {
            _flickity.resize();
        }, true);
        $('.ca-ins-shares .ca-ins-share-item').click(function(){
            if($('body').hasClass('template-product')){
            
            }else{
                var _datahref = $(this).attr('data-href');
                if(typeof _datahref !== 'undefined' && _datahref !== false){
                                    window.location.href = _datahref;
                }	
            }
            
        });
    }*/

$('.ca-swatches-fabric-nav').css('top',$('#HeaderWrapper').height()-1);

$('body').delegate('.casfn-btn','click',function(){

    $('.casfn-btn.casfn-btn-active').removeClass('casfn-btn-active');
    $(this).addClass('casfn-btn-active');
    var _this =this;
    $([document.documentElement, document.body]).animate({
        scrollTop: ($('.ca-swatches-fabric-color').eq($(_this).index()).offset().top - 200)
    }, 150);
    
});


$(window).scroll(function(){
 var _jzx = $(window).scrollTop()+($(window).height()/2);
 if(_jzx>$('.ca-swatches-fabric-color').eq(0).offset().top){

 $('.ca-swatches-fabric-color').each(function(i,v){
    if(_jzx>$(v).offset().top && _jzx<$(v).offset().top+$(v).height()){
        $('.casfn-btn-active').removeClass('casfn-btn-active');
        $('.casfn-btn').eq($(v).index()-1).addClass('casfn-btn-active');
        return;
    }

 });
}

});
    
    $('.ca-swatches-item').click(function(){
        var _this = this;
        $('.ca-swatches-grid .ca-swatches-item-active').removeClass('ca-swatches-item-active');
        $('.ca-swatches-grid .ca-swatches-button-group[style=""]').attr('style','display:none');
        $(' .ca-swatches-item-img-block', _this).addClass('ca-swatches-item-active');
        $(' .ca-swatches-button-group', _this).attr('style','');
        $(' .ca-swatches-view-button', _this).attr('data-href',function(){
            
            return '/products/'+$.trim($(_this).closest('.ca-swatches-fabric-color').find('.ca-swatches-fabric-name').text().toLowerCase()).replace(/\s/,'-')+'-swatches?variant='+getFabricVid(_this)
        });
    });
    function getFabricVid(_this){
        var _fabric =$(_this).closest('.ca-swatches-fabric-color').find('.ca-swatches-fabric-name').text();
        var _color = $(_this).closest('.ca-swatches-item').find('.ca-swatches-item-color-name').text();
        var _vId =0;
        if(_fabric!='' && _color!=''){
            var _fbricData= JSON.parse($('textarea[name="'+_fabric.toLowerCase()+'-swatches"]').val());
            $(_fbricData).each(function(i,v){
                if(v.public_title==_color){
                    _vId = v.id;
                    return false;
                }
            });
        }
        return _vId;
    };

function initAdded(){

    if(typeof (_cart_line_items) != 'undefined'){
        $('.ca-swatches-buy-button').each(function(i,v){
            var _id = getFabricVid(v);
            for(var j =0; j<_cart_line_items.length; j++){
                if(_cart_line_items[j] == _id){
                    $(' .osT76',v).text('In Your Bag!');        
                    $(v).addClass('addedtobag');
                }
            }
        });

    }
};
initAdded();
    $('.ca-swatches-view-button').click(function(){
        var _datahref = $(this).attr('data-href');
      if(typeof _datahref !== 'undefined' && _datahref !== false){
        window.location.href = _datahref;
      }					
    });
    $('.ca-swatches-buy-button').click(function(){
        var _this =this;
        $(_this).addClass('btn--loading');
        let formData = {
         'items': [{
          'id': getFabricVid(_this),
          'quantity': 1
          }]
        };
        fetch(window.Shopify.routes.root + 'cart/add.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json'
          },
          body: JSON.stringify(formData)
        })
        .then(response => {	
            //弹出右侧购物嗲窗口					
            /*document.dispatchEvent(new CustomEvent('ajaxProduct:added', {
                      detail: { }
                    }));*/

            //
            document.dispatchEvent(new CustomEvent('cart:build', {}));

            $(_this).removeClass('btn--loading');

            var $atbfs = $(' .ca-swatches-buy-text',_this);
            $atbfs.html('<em>Added to Bag!</em><svg x="0px" y="0px" width="32px" height="32px" viewBox="0 0 32 32"><path stroke-dasharray="19.79 19.79" stroke-dashoffset="19.79" fill="none" stroke="#FFFFFF" stroke-width="2" stroke-linecap="square" stroke-miterlimit="10" d="M9,17l3.9,3.9c0.1,0.1,0.2,0.1,0.3,0L23,11" style="stroke-dashoffset: 19.79;"></path></svg>');
            $(_this).addClass('addedtobag');
            //$(' .osT76',_this).text('Added to Bag!');
            //$('#SiteHeader .js-drawer-open-cart .cart-link__bubble').addClass('cart-link__bubble--visible');

            $atbfs.addClass('is-added').find('path').eq(0).animate({
                //draw the check icon
                'stroke-dashoffset':0
            }, 300, function(){
                setTimeout(function(){                    
                    $atbfs.removeClass('is-added').find('em').on('webkitTransitionEnd otransitionend oTransitionEnd msTransitionEnd transitionend', function(){
                        //wait for the end of the transition to reset the check icon
                        $atbfs.find('path').eq(0).css('stroke-dashoffset', '19.79');
                    });

                    if( $('.no-csstransitions').length > 0 ) {
                        // check if browser doesn't support css transitions
                        $atbfs.find('path').eq(0).css('stroke-dashoffset', '19.79');
                    }
                }, 600);
            });	

            return response.json();
        })
        .catch((error) => {
          console.error('Error:', error);
        });
    });
});